<template lang="pug">
link-base.link-side-menu(@click='clickEvent', :data-active='isActive')
  image-base.link-side-menu__icon(:src='require(`@/assets/img/${img}`)')
  .link-side-menu__text.font-bold
    slot
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import LinkBase from '@/components/atoms/LinkBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'

/**
 * サイドメニューのアイコン付きリンク
 */
@Component({
  components: {
    LinkBase,
    ImageBase,
  },
})
export default class LinkSideMenu extends Vue {
  // アイコン画像パス
  @Prop()
  img!: string

  // アクティブフラグ
  @Prop()
  isActive!: boolean

  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.link-side-menu
  display flex
  align-items center
  width 182px
  height 42px
  gap 12px
  border-radius 30px
  padding 8px 20px
  text-decoration none

  &:hover
    background-color var(--color-manager-side-menu-link__hover)

  &[data-active='true']
    background-color var(--color-manager-side-menu-link__active)

  &__icon
    width 26px
    height 26px

  &__text
    color var(--color-manager-side-menu-link__text)
</style>
